import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class KickOffPenaltyAccepted extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const nextFragment = play.getNextFragment(fragment);
        return (
            nextFragment.associatedState === FootballState.KickOffPenalty &&
            play.getNextFragment(nextFragment).associatedState ===
                FootballState.KickOffPenaltyAccepted
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        ruleContext.setIsKickoffPenalty(true);
    }
}
